<template>

    <div class="sidebar">

        <div v-if="component === null && componentData === null" class="full-height">

            <div id="canvas-objects-list">

                <h3>{{ currentActive.title }}</h3>

                <i v-if="showPreviewImage" class="material-icons" @click="openPreviewImage">picture_as_pdf</i>

                <p><b>Beschreibung:</b> {{ currentActive.description }}</p>

                <p><b class="display-block">Daten:</b> Druckfläche: {{ currentActive.printArea }}<br> Druckverfahren: {{ currentActive.printType }}</p>

                <h4>Druckelemente:</h4>

                <CanvasObject v-if="item.getVisibility() !== 2 && item.isVisibleInSidebar()" v-for="(item, index) in objectsFromCurrentActive" @levelPlus="levelPlus" @levelMinus="levelMinus" :canvas-object="item" :canvas-objects-length="canvasObjectsLength" @showCanvasObjectView="showCanvasObjectView"></CanvasObject>

                <div class="option-button" style="margin-top: 30px" v-if="currentActive.canvas.getCanAddElements()">
                    <div class="select" style="margin-bottom: 5px;">

                        <select v-model="newElementType">
                            <option disabled value="null">Typ wählen</option>
                            <option v-for="objectType in currentActive.canvas.getCreateableObjectTypes()" :value="objectType.class">{{objectType.name}} hinzufügen</option>
                        </select>

                    </div>

                    <a :disabled="newElementType === null" class="btn" @click="addNewElement">Element hinzufügen</a>
                </div>

            </div>

            <div class="option-button">
                <a class="btn btn-fullsize" @click="clickedSaveAndDownload">Druckdatei downloaden</a>
            </div>

            <div v-if="showSaveOnWishList" class="option-button">
                <a class="btn btn-fullsize" @click="clickedSaveOnWishlistButton">Auf Merkzettel speichern</a>
            </div>

            <div class="option-button">
                <a v-if="!load" class="btn btn-fullsize" @click="clickedAddToBasketButton">In den Warenkorb</a>
                <a v-if="load" class="btn btn-fullsize">

                    <img src="img/loader.gif" alt="">

                </a>
            </div>

        </div>

        <div v-if="component !== null && componentData !== null" class="full-height">

            <div id="customize-selected" >

                <component :is="component" :data="componentData"></component>

            </div>

            <div class="option-button">
                <a class="btn btn-red btn-fullsize" v-if="objectIsDeletable" @click="deleteCanvasObject">Element löschen</a>
            </div>

            <div class="option-button" style="margin-top: 10px">
                <a class="btn btn-fullsize" @click="closeCanvasObjectView">Zurück</a>
            </div>

        </div>


    </div>



</template>

<script>
    import TextObject from "./../structures/canvas-objects/TextObject";
    import ImageObject from "./../structures/canvas-objects/ImageObject";
    import TextboxObject from "../structures/canvas-objects/TextboxObject";
    import MaxWidthTextObject from "../structures/canvas-objects/MaxWidthTextObject";
    import ImageLimitedFormObject from "../structures/canvas-objects/ImageLimitedFormObject";
    import ImageGalleryObject from "../structures/canvas-objects/ImageGalleryObject";
    import Canvas from "./../structures/Canvas";
    import moduleLoader from "../loader/Loader";

    export default {
        name: "CanvasObjectsList",
        components: {
          CanvasObject: () => moduleLoader.loadModule('CanvasObject', 'SimpleCanvasObject')
        },
        props: {
            currentActive: {
                type: Object,
                default: () => ({})
            }
        },
        data: () => ({
            newElementType: null,
            newImage: null,
            component: null,
            componentData: null,
            load: false,
            showSaveOnWishList: false,
            showPreviewImage: false
        }),
        computed: {

            objectsFromCurrentActive() {
                return this.currentActive.canvas.getCanvasObjects().slice().reverse();
            },
            canvasObjectsLength() {
                return this.currentActive.canvas.getNumberOfCanvasObjects();
            },
            objectIsDeletable() {
                const deletable = this.componentData.getDeletable();
                return deletable || window['w2padmin'] === true;
            }

        },
        methods: {
            clickedAddToBasketButton() {
                this.load = true;
                this.$emit('save', { target: 'basket' });
            },
            clickedSaveOnWishlistButton() {
                this.$emit('save', { target: 'wishlist' });
            },
            clickedSaveAndDownload() {
                this.$emit('save', { target: 'download' });
            },
            chosenNewImage(event) {
                this.newImage = event.target.files[0];
            },
            loadComponent(file) {
                return () => import(`./canvas-object-types/${ file }`);
            },
            async addNewElement() {

                const canvas = this.currentActive.canvas;

                let newElement = null;

                if (this.newElementType === TextObject.TYPE_TITLE) {

                    newElement = new TextObject(canvas, 'Textelement');


                } else if (this.newElementType === TextboxObject.TYPE_TITLE) {

                    newElement = new TextboxObject(canvas, 'Textelement');

                }
                else if (this.newElementType === MaxWidthTextObject.TYPE_TITLE) {

                    newElement = new MaxWidthTextObject(canvas, 'Textelement');

                }
                else if (this.newElementType === ImageObject.TYPE_TITLE) {

                    newElement = new ImageObject(canvas, null, 'img/default2.png', 'Keine Datei ausgewählt');

                } else if (this.newElementType === ImageGalleryObject.TYPE_TITLE) {

                    newElement = new ImageGalleryObject(canvas, null, null, 'Keine Datei ausgewählt', true);

                } else if (this.newElementType === ImageLimitedFormObject.TYPE_TITLE) {

                    newElement = new ImageLimitedFormObject(canvas, null, 'img/default2.png', 'Keine Datei ausgewählt');

                } else {

                    alert('Bitte einen Typ auswählen.');
                    return;

                }

                const result = this.currentActive.canvas.addCanvasObject(
                    newElement
                );

                if (result === true) {

                    this.showCanvasObjectView({
                        data: newElement
                    });

                    await canvas.render();

                    newElement.readFromFabricObject();

                    newElement.setTopBoundingBoxInMm(0);
                    newElement.setLeftBoundingBoxInMm(0);

                    await canvas.render();

                }

            },
            async showCanvasObjectView({data}) {

                if (data.getIsSelectable()) {
                    data.getCanvas().getCanvas().discardActiveObject();
                    data.getCanvas().setLastSelectedObjects([data.getId()]);
                    data.getCanvas().render();
                }
                this.componentData = data;
                this.component = await this.loadComponent( data.getViewInObjectsConfigurator() );

            },
            closeCanvasObjectView() {
                this.component = null;
                this.componentData = null;
            },
            deleteCanvasObject() {
                const id = this.componentData.getId();
                console.log(this.componentData);
                this.closeCanvasObjectView();
                this.currentActive.canvas.removeCanvasObjectById(id);
                this.currentActive.canvas.render();
            },
            levelPlus({id}) {

                const object = this.currentActive.canvas.getCanvasObjects().find(canvasObject => canvasObject.getId() === id);

                // Layer cannot be incremented if the element is already the topmost one.
                if (object.getZPosition() === this.currentActive.canvas.getCanvasObjects().length - 1)
                    return;

                const objectBefore = this.currentActive.canvas.getCanvasObjects().find(canvasObject => canvasObject.getZPosition() === object.getZPosition() + 1);

                console.log('#levelPlus() before ', {
                    object, objectBefore
                });

                const temp = object.getZPosition();

                object.setZPosition(objectBefore.getZPosition());

                objectBefore.setZPosition(temp);

                console.log('#levelPlus() after ', {
                    object, objectBefore
                });

                this.currentActive.canvas.render();

            },
            levelMinus({id}) {

                const object = this.currentActive.canvas.getCanvasObjects().find(canvasObject => canvasObject.getId() === id);

                if (object.getZPosition() === 0)
                    return;

                const objectBehind = this.currentActive.canvas.getCanvasObjects().find(canvasObject => canvasObject.getZPosition() === object.getZPosition() - 1);

                console.log('#levelMinus() before ', {
                    object, objectBehind
                });

                const temp = object.getZPosition();

                object.setZPosition(objectBehind.getZPosition());

                objectBehind.setZPosition(temp);

                console.log('#levelMinus() after ', {
                    object, objectBehind
                });

                this.currentActive.canvas.render();

            },
            openPreviewImage() {

                /** @type {Canvas} */
                const canvas = this.currentActive.canvas;

                /** @type {fabric.Canvas} */
                const fabricCanvas = canvas.getCanvas();

                window.open(fabricCanvas.toDataURL(), '_blank');


            }
        },
        mounted() {

            window.EventHandler.$on(
                'clearobjectview',
                () => this.closeCanvasObjectView()
            );

            window.EventHandler.$on(
                'savefinished',
                () => this.load = false
            );

            if (window.hasOwnProperty('addToWishlist')) {
                this.showSaveOnWishList = true;
            }

            if (window.hasOwnProperty('w2pShowImagePreviewIcon')) {
                if (window.w2pShowImagePreviewIcon) {
                    this.showPreviewImage = true;
                }
            }

        }
    }
</script>

<style lang="scss" scoped>

    @import "~@/assets/scss/var";

    .option-button {
        padding: 2px 0;
    }

    .sidebar:first-child .option-button {
        padding: 4px 0 2px 0;
    }

    .sidebar:last-child .option-button {
        padding: 2px 0 0 0;
    }

    #customize-selected, #canvas-objects-list {
        flex-grow: 1;
        flex-shrink: 1;
        overflow: auto;
    }

    h3 {
        color: $blue-color;
        margin: 0;
        font-size: 1.3rem;
    }

    h4 {
        color: $blue-color;
        margin: 40px 0 5px 0;
    }

    p {
        color: $grey-font;
        font-size: 0.9em;

        b.display-block {
            display: block;
        }
    }

    .full-height {
        height: 100%;
        display: flex;
        flex-direction: column;
    }

    .btn {
        display: flex;
        justify-content: center;
        align-items: center;
        padding: 12px;
        box-sizing: border-box;
        background: $blue-color;
        color: #ffffff;
        font-weight: 600;
        font-size: 1rem;
        border-radius: 5px;

        &.btn-red {
            background-color: #D85846;
        }

        &[disabled=disabled] {
            background-color: darken($grey-font, 20);
            cursor: default;
        }

        &:hover {
            cursor: pointer;
        }
    }

    .btn-fullsize {
        height: 100%;
        width: 100%;
    }

    .select {
        box-sizing: border-box;
        width: 100%;
        border: 1px solid $grey-font;
        border-radius: 5px;
        position: relative;
        background-color: #ffffff;

        select {
            font-size: 0.8rem;
            border-radius: 5px;
            margin: 0;
            padding: 0.6rem 2rem 0.6rem 0.4rem;
            border: 0;
            box-sizing: border-box;
            width: 100%;
            -webkit-appearance: none;
            -moz-appearance: none;

            &::-ms-expand {
                display: none;
            }

            &:hover {
                cursor: pointer;
            }
        }

        &::after {
            position: absolute;
            font-family: "Material Icons";
            content: "arrow_drop_down";
            top: 50%;
            margin-top: -.5rem;
            right: .5rem;
            width: 1rem;
            height: 1rem;
            color: $blue-color;
            font-size: 1rem;
        }
    }

</style>
